import React from 'react'
import { Box } from '@mui/material'
import { DashboardLayout } from '../../../types/gotypes'
import { CellRef } from '../../../utils/dashboardBuilderLayout'
import LayoutDropZone from '../layout/LayoutDropZone'
import BuilderCanvasRow from './BuilderCanvasRow'

interface BuilderCanvasProps {
  layout: DashboardLayout
  onDuplicateCell: (ref: CellRef) => void
  onDeleteCell: (ref: CellRef) => void
  onDeleteRow: (rowIndex: number) => void
  onResizeBoundary: (rowIndex: number, boundaryIndex: number, deltaPct: number) => void
  onDistributeEvenly: (rowIndex: number) => void
}

/**
 * The active tab's canvas: an ordered stack of rows, each a horizontal band
 * of one or more widgets (columns). `row-gap` drop zones sit above, between,
 * and below every row so a widget dropped there starts a new row.
 */
const BuilderCanvas: React.FC<BuilderCanvasProps> = ({
  layout,
  onDuplicateCell,
  onDeleteCell,
  onDeleteRow,
  onResizeBoundary,
  onDistributeEvenly,
}) => {
  const isEmpty = layout.rows.length === 0

  return (
    <Box sx={{ p: 3, maxWidth: 1100, mx: 'auto' }}>
      <LayoutDropZone id="rowgap-0" orientation="row" target={{ kind: 'row-gap', index: 0 }} emphasize={isEmpty} />
      {layout.rows.map((row, rowIndex) => (
        <React.Fragment key={rowIndex}>
          <BuilderCanvasRow
            row={row}
            rowIndex={rowIndex}
            onDuplicateCell={onDuplicateCell}
            onDeleteCell={onDeleteCell}
            onDeleteRow={onDeleteRow}
            onResizeBoundary={onResizeBoundary}
            onDistributeEvenly={onDistributeEvenly}
          />
          <LayoutDropZone id={`rowgap-${rowIndex + 1}`} orientation="row" target={{ kind: 'row-gap', index: rowIndex + 1 }} />
        </React.Fragment>
      ))}
    </Box>
  )
}

export default BuilderCanvas
